import { useState, useEffect } from 'react';
import { HostBackend } from '../../Routes/HostBackend.js';
import { GetHeaders } from '../../Components/Admin/Functions/FetchHeaders.js';
import { CarrouselDatas } from '../../Components/Public/Carrousel/CarrouselDatas.js';
import { CarrouselTotal } from '../../Components/Public/Carrousel/CarrouselTotal.js';
import { GetDescription } from '../../Components/Public/Functions/GetDescription.js';
import { ScrollTop } from '../../Components/Public/Functions/ScrollTop.js';
/* document */
import { Navigation } from '../../Components/Public/Document/Navigation.js';
import { Header } from '../../Components/Public/Document/Header.js';
import { Footer } from '../../Components/Public/Document/Footer.js';
import { BreadCrumb } from '../../Components/Public/Document/Breadcrumb.js';
import { BlockLogoArchives } from '../../Components/Public/Logos/BlockLogoArchives.js';
import { InfosArchive } from '../../Components/Public/Blocks/InfosArchive.js';
import { Carrousel } from '../../Components/Public/Carrousel/Carrousel.js';
import { BlockTitleDate2Link1 } from '../../Components/Public/Blocks/BlockTitleDate2Link1.js';
import { BlockOutlink } from '../../Components/Public/Blocks/BlockOutlink.js';
import { BackTop } from '../../Components/Public/Document/BackTop.js';
import { AnimCarrousel } from '../../Components/Public/Functions/AnimCarrousel.js';

export const Archive = (props) => {
    const { navParks, id } = props;
    const backend = HostBackend();
    const guest = sessionStorage.getItem('guest');
    const [archive, setArchive] = useState([]);
    useEffect(() => {
        const fetchtheData = async () => {
            const dataArchive = await fetch(`${backend}/archive?id=${id}`, GetHeaders(guest));
            const archive = await dataArchive.json();
            setArchive(archive);
        };
        fetchtheData();
        ScrollTop();
        AnimCarrousel();
    }, [backend, id, guest]);
    const carrouselDatas = CarrouselDatas('archive', archive);
    const carrouselTotal = CarrouselTotal('archive', archive);
    const items = GetDescription('archive', { archive: archive });
    return (
        <div className="archive">
            <Navigation navParks={navParks} />
            <Header />
            <Carrousel label="archive" datas={carrouselDatas} total={carrouselTotal} />
            <BreadCrumb label="archive" />
            <section className="infos">
                {archive.map((item, i) => {
                    return (
                        <div className="bloc-infos" key={`b-${i}`}>
                            <BlockLogoArchives item={item} />
                            <InfosArchive datas={archive} />
                        </div>
                    )
                })}
                <div className="description">
                    <BlockTitleDate2Link1 label="archive" items={items} />
                    <p>{items.description}</p>
                    <BlockOutlink items={items} />
                </div>
            </section>
            <BackTop />
            <Footer />
        </div>
    )
}